import { FundPerformance } from '../../../dto/FundPerformance';

export enum FpCardsTitle {
  TOTAL = 'Total',
  UNREALIZED = 'Unrealized',
  REALIZED = 'Realized',
  BEFORE_CARRY = 'before carry',
  AFTER_CARRY = 'after carry'
}

export type FpCardValueHeader = 'Investment' | 'Fair value' | 'Escrow companies' | 'Companies'| 'MOIC' | 'IRR'
| 'Escrow' | 'Gain' | 'Loss' | 'Contribution' | 'NAV & Distribution' | 'Distribution' | 'Distribution & DPI'
| 'Fund size' | 'TVPI' | 'NAV & RVPI' | 'NAV & Distribution & Carry' | 'Gain & Carry' | 'Loss & Carry' | 'Carry'
| 'NAV' | 'RVPI' | 'DPI';

export type FpCardsCarryType = 'before carry' | 'after carry';

export interface FpCard {
  mainName: FpCardValueHeader;
  mainValue: string;
  mainIcon?: string;
  secondName?: FpCardValueHeader;
  secondValue?: string;
}


export class FpCardsData {
  total: FpCard[];
  unrealized: FpCard[];
  realized: FpCard[];
  beforeCarry: FpCard[];
  afterCarry: FpCard[];

  constructor(
    total: FpCard[] = [],
    unrealized: FpCard[] = [],
    realized: FpCard[] = [],
    beforeCarry: FpCard[] = [],
    afterCarry: FpCard[] = [],
  ) {
    this.total = total;
    this.unrealized = unrealized;
    this.realized = realized;
    this.beforeCarry = beforeCarry;
    this.afterCarry = afterCarry;
  }
}

export interface IrrInfoRs {
  irr?: number;
  irrAfterCarry?: number;
  irrCanBeCalculated?: boolean;
}

export interface ChosenPPCharts {
  name: 'total' | 'active' | 'realized';
  chosen: boolean;
  showModal: boolean;
}

export const getFundPerfTooltipText = (id: string, fp?: FundPerformance): string => {
  if (id.includes('published')) return fp.isPublished ? 'Investor report shared' : 'No shared investor report';
  if (id.includes('predicted')) return fp.isBasedOnPrognosis ? 'Predicted period' : 'Set as predicted';
  if (id.includes('locked')) return fp.blocked ? 'Locked' : 'Lock period';
  if (id.includes('visible')) {
    if (fp.isPublished) {
      return 'Cannot hide period that has a shared Investor report';
    }
    return fp.isVisible ? 'Hide period' : 'Show period';
  }
  if (id.includes('copy')) return 'Copy period';
  if (id.includes('delete')) return 'Delete period';
  if (id === 'predHeading') return 'Predicted';
  if (id === 'lockHeading') return 'Lock all periods';
  if (id === 'hiddenHeading') return 'Hidden';
  if (id.includes('manual')) return 'Manual IRR';
  if (id.includes('commonReportedPeriod')) return 'Performance as of';
};
